import React from 'react';
import { Card } from '../components/ui/card';
import { CheckCircle } from 'lucide-react';

const WhoItsFor = () => {
  return (
    <div className="bg-gradient-to-b from-[#e8f4fd] to-[#f0f8ff] min-h-screen py-20">
      <div className="max-w-5xl mx-auto px-6">
        <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 text-center">
          Who It's For
        </h1>
        <p className="text-xl text-gray-600 text-center mb-12">
          Levanta is for people who want real structure
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          <Card className="bg-white rounded-3xl p-8">
            <div className="flex items-start gap-4">
              <CheckCircle className="w-6 h-6 text-blue-500 flex-shrink-0 mt-1" />
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">People who want real structure</h3>
                <p className="text-gray-600 leading-relaxed">
                  Content coming soon...
                </p>
              </div>
            </div>
          </Card>

          <Card className="bg-white rounded-3xl p-8">
            <div className="flex items-start gap-4">
              <CheckCircle className="w-6 h-6 text-blue-500 flex-shrink-0 mt-1" />
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Not just motivation</h3>
                <p className="text-gray-600 leading-relaxed">
                  Content coming soon...
                </p>
              </div>
            </div>
          </Card>

          <Card className="bg-white rounded-3xl p-8">
            <div className="flex items-start gap-4">
              <CheckCircle className="w-6 h-6 text-blue-500 flex-shrink-0 mt-1" />
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Not quick fixes</h3>
                <p className="text-gray-600 leading-relaxed">
                  Content coming soon...
                </p>
              </div>
            </div>
          </Card>

          <Card className="bg-white rounded-3xl p-8">
            <div className="flex items-start gap-4">
              <CheckCircle className="w-6 h-6 text-blue-500 flex-shrink-0 mt-1" />
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Adults who take responsibility</h3>
                <p className="text-gray-600 leading-relaxed">
                  Content coming soon...
                </p>
              </div>
            </div>
          </Card>
        </div>

        <div>
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">Personas</h2>
          <p className="text-center text-gray-600">Detailed persona descriptions coming soon...</p>
        </div>
      </div>
    </div>
  );
};

export default WhoItsFor;